/**
 * Exocortex - Entry Point
 *
 * Sistema auxiliar cognitivo para gestión de rutinas
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { ErrorBoundary } from './ui/composed';
import { initSupabaseFromEnv } from './services/sync';
import './styles/globals.css';

// Inicializar Supabase desde variables de entorno
initSupabaseFromEnv();

// Registrar Service Worker para PWA (solo en producción)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('SW registration failed:', error);
    });
  });
}

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
